import CartIcon from '@src/assets/icons/ic_cart.svg';
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CartModalPresenter from '@src/cart/cartModalPresenter.js';
import { useUser } from '@src/services/userContext';
import { useTranslation } from 'react-i18next';
import { Button } from 'theme-ui';
import './CartButton.scss';

type CartButtonProps = {
  className?: string;
};

const CartButton = ({ className }: CartButtonProps) => {
  const { t } = useTranslation();
  const cartModalPresenter = new CartModalPresenter();

  const user = useUser();
  const [cartCount, setCartCount] = useState(0);
  useEffect(() => {
    const updateView = (cartListVm: { cartCount: number }) => {
      if (cartListVm?.cartCount >= 0) {
        setCartCount(cartListVm?.cartCount);
      }
    };
    if (user?.email) {
      cartModalPresenter.loadCartItems(updateView, user);
    }

    // return updateView;
  }, [user]);

  return (
    <Button
      variant="empty"
      sx={{ marginLeft: 4 }}
      className={`${className}`}
      type="button"
      onClick={() => {
        cartModalPresenter.toggleModal();
      }}
      title={t('cart')}
    >
      <div className="cart__container">
        <CartIcon />
        {cartCount > 0 ? (
          <span className="cart__bubble">{cartCount}</span>
        ) : (
          <></>
        )}
      </div>
    </Button>
  );
};

export default CartButton;
